import {
   BACKUP_DATABASE,
   BACKUP_DATABASE_ERROR,
   BACKUP_DATABASE_START,
   BACKUP_DATABASE_SUCCESS,
   GENERATE_BULK_EWAY_EINVOICE,
   GET_EWAYBILL_AND_EINVOICE,
} from '../types';
import { POST_MERGE_CODE, POST_COLUMNS_HIDE_SHOW } from '../types';

const initialState = {
   list: [],
   single: null,
   backup: {
      loading: false,
      success: false,
      error: null,
      filename: null,
      size: null,
      timestamp: null,
      message: null,
      status: null,
   },
   ewayBillAndEinvoice: [],
   generateBulkEwayEinvoice: [],
};

const reducer = (state = initialState, action) => {
   const { type, payload } = action;

   switch (type) {
      case POST_MERGE_CODE:
         return { ...state, list: payload };

      case POST_COLUMNS_HIDE_SHOW:
         return { ...state, list: payload };

      case BACKUP_DATABASE:
         return {
            ...state,
            single: payload || null,
            backup: {
               ...state.backup,
               success: payload?.success || false,
               message: payload?.message || null,
            },
         };

      // New enhanced backup actions
      case BACKUP_DATABASE_START:
         return {
            ...state,
            backup: {
               ...state.backup,
               loading: true,
               success: false,
               error: null,
               message: null,
            },
         };

      case BACKUP_DATABASE_SUCCESS:
         return {
            ...state,
            backup: {
               ...state.backup,
               loading: false,
               success: true,
               error: null,
               filename: payload.filename,
               size: payload.size,
               timestamp: payload.timestamp,
               message: payload.message,
            },
         };

      case BACKUP_DATABASE_ERROR:
         return {
            ...state,
            backup: {
               ...state.backup,
               loading: false,
               success: false,
               error: payload.error,
               message: payload.error,
               filename: null,
               size: null,
               timestamp: null,
            },
         };

      case GET_EWAYBILL_AND_EINVOICE:
         return { ...state, ewayBillAndEinvoice: payload };

      case GENERATE_BULK_EWAY_EINVOICE:
         return { ...state, generateBulkEwayEinvoice: payload };

      default:
         return state;
   }
};

export default reducer;
